import { T } from "../../../app/tokens.js";
import { NavRailIcon } from "../../../components/NavRailIcon.jsx";
import { portfolioLinkSlots, PORTFOLIO_SLOT_SIZE, PORTFOLIO_SLOT_GAP } from "./portfolioLinkSlots.js";
import "./ProjectConnections.css";

export function PortfolioLinkSlots({ connections }) {
  const entries = portfolioLinkSlots(connections);
  return (
    <span data-testid="project-portfolio-link-slots" className="project-portfolio-link-slots"
      role="group" aria-label="Project links"
      onClick={event => event.stopPropagation()}
      onKeyDown={event => event.stopPropagation()}
      style={{ "--connection-accent": T.blue, "--connection-muted": T.mid,
        "--connection-border": T.border, "--connection-bg": T.card,
        "--portfolio-slot-size": `${PORTFOLIO_SLOT_SIZE}px`, gap: PORTFOLIO_SLOT_GAP }}>
      {entries.map(entry => {
        const props = {
          className: `project-connection-link project-portfolio-link-slot${entry.href ? "" : " is-missing"}`,
          "data-testid": `portfolio-slot-${entry.kind}`,
          "data-kind": entry.kind,
          "aria-label": entry.label,
          title: entry.label,
          children: <span aria-hidden="true"><NavRailIcon itemKey={entry.icon} size={14} /></span>,
        };
        return entry.href
          ? <a key={entry.kind} {...props} href={entry.href}
              target={entry.external ? "_blank" : undefined} rel={entry.external ? "noopener noreferrer" : undefined} />
          : <span key={entry.kind} {...props} role="img" aria-disabled="true" />;
      })}
    </span>
  );
}
